interface ParamsProps {
  isAdmProcess: boolean;
}

export class AdminByProcessParams {
  static admType: ParamsProps;
}
